if (!customElements.get('calc-shipping-rate-block')) {
  const STORAGE_KEY = 'f-cart-selected-shipping-rate';
  const ZIP_LENGTH = 8;
  const DEBOUNCE_TIME = 550;

  const BRAZIL_PROVINCES_BY_ZIP = [
    { min: 1000, max: 19999, province: 'São Paulo', provinceCode: 'SP' },
    { min: 20000, max: 28999, province: 'Rio de Janeiro', provinceCode: 'RJ' },
    { min: 29000, max: 29999, province: 'Espírito Santo', provinceCode: 'ES' },
    { min: 30000, max: 39999, province: 'Minas Gerais', provinceCode: 'MG' },
    { min: 40000, max: 48999, province: 'Bahia', provinceCode: 'BA' },
    { min: 49000, max: 49999, province: 'Sergipe', provinceCode: 'SE' },
    { min: 50000, max: 56999, province: 'Pernambuco', provinceCode: 'PE' },
    { min: 57000, max: 57999, province: 'Alagoas', provinceCode: 'AL' },
    { min: 58000, max: 58999, province: 'Paraíba', provinceCode: 'PB' },
    { min: 59000, max: 59999, province: 'Rio Grande do Norte', provinceCode: 'RN' },
    { min: 60000, max: 63999, province: 'Ceará', provinceCode: 'CE' },
    { min: 64000, max: 64999, province: 'Piauí', provinceCode: 'PI' },
    { min: 65000, max: 65999, province: 'Maranhão', provinceCode: 'MA' },
    { min: 66000, max: 68899, province: 'Pará', provinceCode: 'PA' },
    { min: 68900, max: 68999, province: 'Amapá', provinceCode: 'AP' },
    { min: 69000, max: 69299, province: 'Amazonas', provinceCode: 'AM' },
    { min: 69300, max: 69399, province: 'Roraima', provinceCode: 'RR' },
    { min: 69400, max: 69899, province: 'Amazonas', provinceCode: 'AM' },
    { min: 69900, max: 69999, province: 'Acre', provinceCode: 'AC' },
    { min: 70000, max: 72799, province: 'Distrito Federal', provinceCode: 'DF' },
    { min: 72800, max: 72999, province: 'Goiás', provinceCode: 'GO' },
    { min: 73000, max: 73699, province: 'Distrito Federal', provinceCode: 'DF' },
    { min: 73700, max: 76799, province: 'Goiás', provinceCode: 'GO' },
    { min: 77000, max: 77999, province: 'Tocantins', provinceCode: 'TO' },
    { min: 78000, max: 78899, province: 'Mato Grosso', provinceCode: 'MT' },
    { min: 78900, max: 78999, province: 'Rondônia', provinceCode: 'RO' },
    { min: 79000, max: 79999, province: 'Mato Grosso do Sul', provinceCode: 'MS' },
    { min: 80000, max: 87999, province: 'Paraná', provinceCode: 'PR' },
    { min: 88000, max: 89999, province: 'Santa Catarina', provinceCode: 'SC' },
    { min: 90000, max: 99999, province: 'Rio Grande do Sul', provinceCode: 'RS' },
  ];

  const UF_TO_STATE_NAME = {
    AC: 'Acre',
    AL: 'Alagoas',
    AP: 'Amapá',
    AM: 'Amazonas',
    BA: 'Bahia',
    CE: 'Ceará',
    DF: 'Distrito Federal',
    ES: 'Espírito Santo',
    GO: 'Goiás',
    MA: 'Maranhão',
    MT: 'Mato Grosso',
    MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais',
    PA: 'Pará',
    PB: 'Paraíba',
    PR: 'Paraná',
    PE: 'Pernambuco',
    PI: 'Piauí',
    RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte',
    RS: 'Rio Grande do Sul',
    RO: 'Rondônia',
    RR: 'Roraima',
    SC: 'Santa Catarina',
    SP: 'São Paulo',
    SE: 'Sergipe',
    TO: 'Tocantins',
  };

  const MANUAL_LOCAL_DELIVERY_RULE = {
    enabled: true,
    name: 'Entrega Local',
    centerZip: '22430090',
    radiusKm: 10,
    priceCents: 0,
    centerCoordinates: {
      latitude: -22.9803335,
      longitude: -43.2202938,
    },
  };

  const ZIP_COORDINATES_CACHE = new Map();

  const moneyFormat = () => {
    return window.FoxThemeSettings?.money_format || window.themeVariables?.settings?.moneyFormat || 'R$ {{amount_with_comma_separator}}';
  };

  function toDigits(value) {
    return String(value || '').replace(/\D/g, '').slice(0, ZIP_LENGTH);
  }

  function formatZip(value) {
    const digits = toDigits(value);

    if (digits.length > 5) {
      return `${digits.slice(0, 5)}-${digits.slice(5)}`;
    }

    return digits;
  }

  function normalizeText(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function normalizeCountry(country) {
    const value = String(country || '').trim();

    if (!value) return 'Brazil';

    const normalized = normalizeText(value);

    if (normalized === 'brasil' || normalized === 'br') return 'Brazil';

    return value;
  }

  function detectBrazilProvinceFromZip(zip) {
    const digits = toDigits(zip);

    if (digits.length < ZIP_LENGTH) return null;

    const prefix = Number.parseInt(digits.slice(0, 5), 10);

    if (!Number.isFinite(prefix)) return null;

    return BRAZIL_PROVINCES_BY_ZIP.find((range) => {
      return prefix >= range.min && prefix <= range.max;
    }) || null;
  }

  function parseMoneyToCents(value) {
    const text = String(value || '').trim();

    if (!text) return 0;

    let normalized = text.replace(/[^\d,.-]/g, '');

    if (!normalized) return 0;

    if (normalized.includes(',')) {
      normalized = normalized.replace(/\./g, '').replace(',', '.');
    }

    const parsed = Number.parseFloat(normalized);

    return Number.isFinite(parsed) ? Math.round(parsed * 100) : 0;
  }

  function priceToCents(rate) {
    if (!rate) return 0;

    if (typeof rate.price_cents === 'number') {
      return rate.price_cents;
    }

    if (typeof rate.price === 'number') {
      return Math.round(rate.price * 100);
    }

    return parseMoneyToCents(rate.price || '0');
  }

  function formatPrice(cents) {
    if (typeof formatMoney === 'function') {
      return formatMoney(cents, moneyFormat());
    }

    return (Number(cents || 0) / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }

  function getDeliveryText(rate) {
    if (!rate) return '';

    if (Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0) {
      const days = rate.delivery_days
        .map((day) => Number.parseInt(day, 10))
        .filter((day) => Number.isFinite(day));

      if (days.length > 0) {
        const maxDays = Math.max(...days);
        return `${maxDays} DIAS ÚTEIS`;
      }
    }

    const deliveryText = rate.delivery_date || rate.delivery_range || rate.description || '';

    return String(deliveryText).trim().toUpperCase();
  }

  function getShippingRateDisplayName(rate) {
    return String(rate?.name || '').trim();
  }

  function buildRateLabel(rate) {
    const rateName = getShippingRateDisplayName(rate);
    const price = formatPrice(priceToCents(rate));
    const deliveryText = getDeliveryText(rate);

    return `${rateName} - ${price}${deliveryText ? ` (${deliveryText})` : ''}`;
  }

  function extractCoordinatesFromBrasilApi(data) {
    const coordinates = data?.location?.coordinates;

    if (!coordinates) return null;

    const latitude = Number.parseFloat(coordinates.latitude ?? coordinates.lat ?? coordinates[1]);
    const longitude = Number.parseFloat(coordinates.longitude ?? coordinates.lng ?? coordinates.lon ?? coordinates[0]);

    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;

    return { latitude, longitude };
  }

  async function fetchCoordinatesByZip(zip, signal) {
    const digits = toDigits(zip);

    if (digits.length !== ZIP_LENGTH) return null;

    if (digits === MANUAL_LOCAL_DELIVERY_RULE.centerZip) {
      return MANUAL_LOCAL_DELIVERY_RULE.centerCoordinates;
    }

    if (ZIP_COORDINATES_CACHE.has(digits)) {
      return ZIP_COORDINATES_CACHE.get(digits);
    }

    try {
      const response = await fetch(`https://brasilapi.com.br/api/cep/v2/${digits}`, { signal });

      if (!response.ok) {
        ZIP_COORDINATES_CACHE.set(digits, null);
        return null;
      }

      const data = await response.json();
      const coordinates = extractCoordinatesFromBrasilApi(data);

      ZIP_COORDINATES_CACHE.set(digits, coordinates);

      return coordinates;
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.warn('[ECOMHARD] Não foi possível buscar coordenadas do CEP:', error);
      }

      return null;
    }
  }

  function degreesToRadians(value) {
    return (Number(value) * Math.PI) / 180;
  }

  function calculateDistanceInKm(origin, destination) {
    if (!origin || !destination) return null;

    const originLatitude = Number.parseFloat(origin.latitude);
    const originLongitude = Number.parseFloat(origin.longitude);
    const destinationLatitude = Number.parseFloat(destination.latitude);
    const destinationLongitude = Number.parseFloat(destination.longitude);

    if (
      !Number.isFinite(originLatitude) ||
      !Number.isFinite(originLongitude) ||
      !Number.isFinite(destinationLatitude) ||
      !Number.isFinite(destinationLongitude)
    ) {
      return null;
    }

    const earthRadiusInKm = 6371;
    const latitudeDistance = degreesToRadians(destinationLatitude - originLatitude);
    const longitudeDistance = degreesToRadians(destinationLongitude - originLongitude);
    const a =
      Math.sin(latitudeDistance / 2) * Math.sin(latitudeDistance / 2) +
      Math.cos(degreesToRadians(originLatitude)) *
        Math.cos(degreesToRadians(destinationLatitude)) *
        Math.sin(longitudeDistance / 2) *
        Math.sin(longitudeDistance / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return earthRadiusInKm * c;
  }

  function isLocalDeliveryRate(rate) {
    const name = normalizeText(rate?.name || '');

    return name.includes('entrega local') || name.includes('local delivery');
  }

  async function buildManualLocalDeliveryRate(zip, signal) {
    if (!MANUAL_LOCAL_DELIVERY_RULE.enabled) return null;

    const digits = toDigits(zip);

    if (digits.length !== ZIP_LENGTH) return null;

    const coordinates = await fetchCoordinatesByZip(digits, signal);

    if (!coordinates) return null;

    const distanceKm = calculateDistanceInKm(
      MANUAL_LOCAL_DELIVERY_RULE.centerCoordinates,
      coordinates
    );

    if (!Number.isFinite(distanceKm) || distanceKm > MANUAL_LOCAL_DELIVERY_RULE.radiusKm) {
      return null;
    }

    return {
      name: MANUAL_LOCAL_DELIVERY_RULE.name,
      price: '0.00',
      price_cents: MANUAL_LOCAL_DELIVERY_RULE.priceCents,
      description: '',
      delivery_days: [],
      _ecomhardManualLocalDelivery: true,
      _ecomhardDistanceKm: distanceKm,
    };
  }

  function mergeManualLocalDeliveryRate(rates, manualLocalDeliveryRate) {
    const safeRates = Array.isArray(rates) ? [...rates] : [];

    if (!manualLocalDeliveryRate) return safeRates;

    const alreadyHasLocalDelivery = safeRates.some(isLocalDeliveryRate);

    if (alreadyHasLocalDelivery) return safeRates;

    return [manualLocalDeliveryRate, ...safeRates];
  }

  function getStoredShipping() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function setStoredShipping(payload) {
    try {
      if (!payload) {
        sessionStorage.removeItem(STORAGE_KEY);
        return;
      }

      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {
      // sessionStorage pode estar bloqueado em alguns navegadores.
    }
  }

  function getErrorMessageFromResult(result) {
    if (!result || typeof result !== 'object') return '';

    const firstError = Object.values(result).find((value) => {
      return Array.isArray(value) && value.length;
    });

    return firstError ? firstError[0] : '';
  }

  async function fetchAddressByZip(zip) {
    const digits = toDigits(zip);

    if (digits.length !== ZIP_LENGTH) return null;

    try {
      const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`);

      if (!response.ok) return null;

      const data = await response.json();

      if (!data || data.erro) return null;

      const provinceCode = String(data.uf || '').trim().toUpperCase();
      const province = UF_TO_STATE_NAME[provinceCode] || provinceCode;

      return {
        zip: formatZip(digits),
        zipDigits: digits,
        address1: String(data.logradouro || '').trim(),
        neighborhood: String(data.bairro || '').trim(),
        city: String(data.localidade || '').trim(),
        provinceCode,
        province,
        country: 'Brazil',
      };
    } catch (error) {
      console.warn('[ECOMHARD] Não foi possível buscar endereço pelo CEP:', error);
      return null;
    }
  }

  function buildFallbackAddress(zip) {
    const detectedProvince = detectBrazilProvinceFromZip(zip);
    const digits = toDigits(zip);

    return {
      zip: formatZip(digits),
      zipDigits: digits,
      address1: '',
      neighborhood: '',
      city: '',
      provinceCode: detectedProvince?.provinceCode || '',
      province: detectedProvince?.province || '',
      country: 'Brazil',
    };
  }

  function buildCheckoutUrl(address) {
    const url = new URL('/checkout', window.location.origin);

    if (!address) {
      return url.toString();
    }

    url.searchParams.set('checkout[shipping_address][zip]', address.zip || address.zipDigits || '');
    url.searchParams.set('checkout[shipping_address][country]', address.country || 'Brazil');

    if (address.province) {
      url.searchParams.set('checkout[shipping_address][province]', address.province);
    }

    if (address.city) {
      url.searchParams.set('checkout[shipping_address][city]', address.city);
    }

    if (address.address1) {
      url.searchParams.set('checkout[shipping_address][address1]', address.address1);
    }

    return url.toString();
  }

  async function fetchShippingRates({ zip, country, province, provinceCode, city, address1, signal }) {
    const url = new URL('/cart/shipping_rates.json', window.location.origin);

    url.searchParams.set('shipping_address[zip]', formatZip(zip));
    url.searchParams.set('shipping_address[country]', normalizeCountry(country || 'Brazil'));

    if (province) {
      url.searchParams.set('shipping_address[province]', province);
    }

    if (provinceCode) {
      url.searchParams.set('shipping_address[province_code]', provinceCode);
    }

    if (city) {
      url.searchParams.set('shipping_address[city]', city);
    }

    if (address1) {
      url.searchParams.set('shipping_address[address1]', address1);
    }

    const response = await fetch(url.toString(), { signal });
    const result = await response.json();

    return result;
  }

  customElements.define(
    'calc-shipping-rate-block',
    class FooterCalcShippingRates extends HTMLElement {
      constructor() {
        super();

        this.rates = [];
        this.selectedRate = null;
        this.selectedRateIndex = 0;
        this.debounceTimer = null;
        this.abortController = null;
        this.initialized = false;
        this.checkoutAddress = null;
        this.isRedirectingToCheckout = false;
        this.cartUpdateUnsubscriber = null;

        this.handleInput = this.handleInput.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleRateChange = this.handleRateChange.bind(this);
        this.handleCartUpdate = this.handleCartUpdate.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleCheckoutClick = this.handleCheckoutClick.bind(this);
        this.handleCheckoutSubmit = this.handleCheckoutSubmit.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;

        this.selectors = {
          zipCode: '[name="address[zip]"]',
          province: '[name="address[province]"]',
          country: '[name="address[country]"]',
          message: '[data-shipping-message]',
          price: '[data-shipping-price]',
          clearButton: '[data-shipping-clear]',
          countries: 'template',
        };

        this.domNodes = {
          zipCode: this.querySelector(this.selectors.zipCode),
          province: this.querySelector(this.selectors.province),
          country: this.querySelector(this.selectors.country),
          message: this.querySelector(this.selectors.message),
          price: this.querySelector(this.selectors.price),
          clearButton: this.querySelector(this.selectors.clearButton),
          countries: this.querySelector(this.selectors.countries),
        };

        if (!this.domNodes.zipCode || !this.domNodes.message || !this.domNodes.price) return;

        this.setupNativeAddressFields();

        this.domNodes.zipCode.value = formatZip(this.domNodes.zipCode.value);

        this.domNodes.zipCode.addEventListener('input', this.handleInput);
        this.domNodes.zipCode.addEventListener('keydown', this.handleKeydown);
        this.domNodes.zipCode.addEventListener('blur', () => {
          this.domNodes.zipCode.value = formatZip(this.domNodes.zipCode.value);
        });

        if (this.domNodes.clearButton) {
          this.domNodes.clearButton.addEventListener('click', this.handleClear);
        }

        document.addEventListener('cart:updated', this.handleCartUpdate);
        document.addEventListener('click', this.handleCheckoutClick, true);
        document.addEventListener('submit', this.handleCheckoutSubmit, true);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS?.cartUpdate) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate);
        }

        this.restorePreviousShipping();
      }

      disconnectedCallback() {
        document.removeEventListener('cart:updated', this.handleCartUpdate);
        document.removeEventListener('click', this.handleCheckoutClick, true);
        document.removeEventListener('submit', this.handleCheckoutSubmit, true);

        if (typeof this.cartUpdateUnsubscriber === 'function') {
          this.cartUpdateUnsubscriber();
        }

        if (this.domNodes?.clearButton) {
          this.domNodes.clearButton.removeEventListener('click', this.handleClear);
        }

        if (this.abortController) {
          this.abortController.abort();
        }
      }

      getCartRoot() {
        return (
          this.closest('cart-drawer') ||
          this.closest('.cart-drawer') ||
          this.closest('form[action="/cart"]') ||
          this.closest('form[action$="/cart"]') ||
          document
        );
      }

      setupNativeAddressFields() {
        const { country, countries } = this.domNodes || {};

        if (country && countries && !country.options.length) {
          country.innerHTML = countries.innerHTML;
        }

        if (country) {
          const preferredCountry = country.dataset.default || this.dataset.defaultCountry || 'Brazil';
          const preferred = normalizeText(preferredCountry);
          const options = Array.from(country.options || []);
          const match = options.find((option) => {
            const value = normalizeText(option.value);
            const text = normalizeText(option.textContent);

            return (
              value === preferred ||
              text === preferred ||
              value === 'brazil' ||
              text === 'brazil' ||
              value === 'brasil' ||
              text === 'brasil'
            );
          });

          if (match) {
            country.value = match.value;
          }
        }
      }

      setHiddenAddressFields(address) {
        if (!address) return;

        if (this.domNodes.country) {
          this.domNodes.country.value = this.domNodes.country.value || address.country || 'Brazil';
        }

        if (this.domNodes.province) {
          this.domNodes.province.innerHTML = '';

          const option = document.createElement('option');
          option.value = address.province || address.provinceCode || '';
          option.textContent = address.province || address.provinceCode || '';
          option.selected = true;

          this.domNodes.province.appendChild(option);
        }
      }

      handleCartUpdate() {
        window.setTimeout(() => {
          const zipDigits = toDigits(this.domNodes?.zipCode?.value || '');

          if (zipDigits.length === ZIP_LENGTH) {
            this.fetchRates({ keepSelectedIndex: true });
            return;
          }

          this.updateTotal();
        }, 150);
      }

      handleInput(event) {
        const formattedZip = formatZip(event.target.value);
        event.target.value = formattedZip;

        const zipDigits = toDigits(formattedZip);

        this.checkoutAddress = null;

        if (zipDigits.length < ZIP_LENGTH) {
          this.clearRates();
          return;
        }

        window.clearTimeout(this.debounceTimer);

        this.debounceTimer = window.setTimeout(() => {
          this.fetchRates();
        }, DEBOUNCE_TIME);
      }

      handleKeydown(event) {
        if (event.key !== 'Enter') return;

        event.preventDefault();

        const zipDigits = toDigits(this.domNodes.zipCode.value);

        if (zipDigits.length === ZIP_LENGTH) {
          window.clearTimeout(this.debounceTimer);
          this.fetchRates();
        }
      }

      handleRateChange(event) {
        this.selectRate(Number(event.target.value));
      }

      handleClear(event) {
        event.preventDefault();

        if (this.abortController) {
          this.abortController.abort();
        }

        window.clearTimeout(this.debounceTimer);

        this.domNodes.zipCode.value = '';
        this.domNodes.message.innerHTML = '';
        this.rates = [];
        this.checkoutAddress = null;

        this.clearSelectedShipping(true);
        this.setLoading(false);

        this.domNodes.zipCode.focus();
      }

      handleCheckoutClick(event) {
        if (!(event.target instanceof Element)) return;

        const checkoutButton = event.target.closest(
          'button[name="checkout"], input[name="checkout"], [data-checkout-button]'
        );

        if (!checkoutButton) return;

        const cartRoot = this.getCartRoot();

        if (cartRoot !== document && !cartRoot.contains(checkoutButton)) return;

        event.preventDefault();
        event.stopPropagation();

        this.redirectToCheckout();
      }

      handleCheckoutSubmit(event) {
        const form = event.target;

        if (!(form instanceof HTMLFormElement)) return;

        const cartRoot = this.getCartRoot();

        if (cartRoot !== document && !cartRoot.contains(form)) return;

        const checkoutSelector = 'button[name="checkout"], input[name="checkout"], [data-checkout-button]';
        const submitter = event.submitter;

        if (submitter instanceof Element && !submitter.matches(checkoutSelector)) return;

        const hasCheckoutButton = form.querySelector(checkoutSelector);

        if (!hasCheckoutButton) return;

        event.preventDefault();
        event.stopPropagation();

        this.redirectToCheckout();
      }

      async redirectToCheckout() {
        if (this.isRedirectingToCheckout) return;

        this.isRedirectingToCheckout = true;

        const zip = toDigits(this.domNodes.zipCode?.value || '');

        try {
          if (zip.length === ZIP_LENGTH && !this.checkoutAddress) {
            this.checkoutAddress = (await fetchAddressByZip(zip)) || buildFallbackAddress(zip);
          }

          window.location.href = buildCheckoutUrl(this.checkoutAddress);
        } catch (error) {
          console.warn('[ECOMHARD] Erro ao redirecionar para checkout:', error);
          window.location.href = '/checkout';
        }
      }

      async restorePreviousShipping() {
        const storedShipping = getStoredShipping();

        if (!storedShipping?.zip) return;

        this.selectedRateIndex = Number(storedShipping.index || 0);
        this.domNodes.zipCode.value = formatZip(storedShipping.zip);

        await this.fetchRates({ keepSelectedIndex: true });
      }

      async fetchRates(options = {}) {
        const zip = toDigits(this.domNodes.zipCode.value);

        if (zip.length !== ZIP_LENGTH) return;

        if (this.abortController) {
          this.abortController.abort();
        }

        this.abortController = new AbortController();
        const currentController = this.abortController;

        this.setLoading(true);
        this.domNodes.message.innerHTML = '';

        try {
          const address = (await fetchAddressByZip(zip)) || buildFallbackAddress(zip);
          const currentZip = toDigits(this.domNodes.zipCode?.value || '');

          if (currentZip !== zip) return;

          this.checkoutAddress = address;
          this.setHiddenAddressFields(address);

          if (!address.province && !address.provinceCode) {
            this.renderMessage('Não foi possível identificar o estado desse CEP.');
            this.clearSelectedShipping(false);
            return;
          }

          const country = normalizeCountry(address.country || this.domNodes.country?.value || this.dataset.defaultCountry || 'Brazil');

          let result = await fetchShippingRates({
            zip,
            country,
            province: address.province,
            provinceCode: address.provinceCode,
            city: address.city,
            address1: address.address1,
            signal: this.abortController.signal,
          });

          if (
            (!Array.isArray(result?.shipping_rates) || result.shipping_rates.length === 0) &&
            address.provinceCode &&
            address.province &&
            normalizeText(address.provinceCode) !== normalizeText(address.province)
          ) {
            result = await fetchShippingRates({
              zip,
              country,
              province: address.provinceCode,
              provinceCode: address.provinceCode,
              city: address.city,
              address1: address.address1,
              signal: this.abortController.signal,
            });
          }

          const manualLocalDeliveryRate = await buildManualLocalDeliveryRate(
            zip,
            this.abortController.signal
          );

          const mergedShippingRates = mergeManualLocalDeliveryRate(
            result?.shipping_rates,
            manualLocalDeliveryRate
          );

          if (mergedShippingRates.length > 0) {
            this.renderRates(mergedShippingRates, options);
            return;
          }

          if (Array.isArray(result?.shipping_rates) && result.shipping_rates.length === 0) {
            this.renderMessage(
              window.FoxThemeStrings?.noShippingRate ||
                'Não encontramos fretes para esse CEP. Você ainda pode finalizar a compra para confirmar no checkout.'
            );
            this.clearSelectedShipping(false);
            return;
          }

          const errorMessage = this.getErrorMessage(result);

          this.renderMessage(errorMessage || window.FoxThemeStrings?.cartError || 'Não foi possível calcular o frete.');
          this.clearSelectedShipping(false);
        } catch (error) {
          if (error.name === 'AbortError') return;

          this.renderMessage(window.FoxThemeStrings?.cartError || 'Não foi possível calcular o frete.');
          this.clearSelectedShipping(false);
        } finally {
          if (this.abortController === currentController) {
            this.setLoading(false);
          }
        }
      }

      getSafeSelectedIndex(options = {}) {
        const storedShipping = getStoredShipping();

        if (options.keepSelectedIndex && storedShipping?.name) {
          const storedName = normalizeText(storedShipping.name);
          const storedOriginalName = normalizeText(storedShipping.originalName);

          const matchedIndex = this.rates.findIndex((rate) => {
            const name = normalizeText(getShippingRateDisplayName(rate));
            const originalName = normalizeText(rate?.name || '');

            return name === storedName || originalName === storedOriginalName;
          });

          if (matchedIndex >= 0) return matchedIndex;
        }

        const requestedIndex = options.keepSelectedIndex ? this.selectedRateIndex : 0;

        return this.rates[requestedIndex] ? requestedIndex : 0;
      }

      renderRates(rates, options = {}) {
        this.rates = Array.isArray(rates) ? rates : [];
        this.domNodes.message.innerHTML = '';

        if (!this.rates.length) {
          this.renderMessage(window.FoxThemeStrings?.noShippingRate || 'Não encontramos fretes para esse CEP.');
          this.clearSelectedShipping(false);
          return;
        }

        const select = document.createElement('select');

        select.className = 'f-cart-shipping__select';
        select.setAttribute('aria-label', 'Escolha o frete');

        this.rates.forEach((rate, index) => {
          const option = document.createElement('option');

          option.value = String(index);
          option.textContent = buildRateLabel(rate);
          option.dataset.priceCents = String(priceToCents(rate));

          select.appendChild(option);
        });

        select.addEventListener('change', this.handleRateChange);

        this.domNodes.message.appendChild(select);

        const safeIndex = this.getSafeSelectedIndex(options);

        select.value = String(safeIndex);

        this.selectRate(safeIndex);
      }

      selectRate(index = 0) {
        const rate = this.rates[index];

        if (!rate) {
          this.clearSelectedShipping(false);
          return;
        }

        const zip = toDigits(this.domNodes.zipCode.value);
        const priceCents = priceToCents(rate);
        const displayName = getShippingRateDisplayName(rate);

        this.selectedRate = rate;
        this.selectedRateIndex = index;

        this.domNodes.price.textContent = formatPrice(priceCents);

        this.classList.add('has-rates');

        if (this.domNodes.clearButton) {
          this.domNodes.clearButton.removeAttribute('hidden');
        }

        this.updateTotal(priceCents);

        setStoredShipping({
          zip,
          index,
          priceCents,
          name: displayName,
          originalName: rate.name,
          province: this.checkoutAddress?.province || '',
          provinceCode: this.checkoutAddress?.provinceCode || '',
          isManualLocalDelivery: Boolean(rate._ecomhardManualLocalDelivery),
        });
      }

      clearRates() {
        window.clearTimeout(this.debounceTimer);

        this.domNodes.message.innerHTML = '';
        this.rates = [];

        this.clearSelectedShipping(true);
      }

      clearSelectedShipping(clearStorage = true) {
        this.selectedRate = null;
        this.selectedRateIndex = 0;

        this.classList.remove('has-rates');

        this.domNodes.price.textContent = '--';

        if (this.domNodes.clearButton) {
          this.domNodes.clearButton.setAttribute('hidden', 'hidden');
        }

        this.updateTotal(null);

        if (clearStorage) {
          setStoredShipping(null);
        }
      }

      getSubtotalCents() {
        const cartRoot = this.getCartRoot();
        const scopedQuery = (selector) => {
          if (cartRoot && cartRoot !== document) {
            return cartRoot.querySelector(selector);
          }

          return document.querySelector(selector);
        };

        const subtotalWrapper = scopedQuery('[data-cart-subtotal-cents]');

        if (subtotalWrapper) {
          const subtotalCents = Number.parseInt(subtotalWrapper.dataset.cartSubtotalCents || '0', 10);

          if (Number.isFinite(subtotalCents) && subtotalCents >= 0) {
            return subtotalCents;
          }
        }

        const priceElement = scopedQuery('[data-cart-price], .totals__total-value');

        if (priceElement) {
          return parseMoneyToCents(priceElement.textContent);
        }

        return 0;
      }

      getOrCreateTotalRow() {
        const cartRoot = this.getCartRoot();
        const scopedQuery = (selector) => {
          if (cartRoot && cartRoot !== document) {
            return cartRoot.querySelector(selector);
          }

          return document.querySelector(selector);
        };

        let totalRow = scopedQuery('[data-cart-shipping-total-row]');

        if (totalRow) return totalRow;

        const subtotalRow = scopedQuery('[data-cart-subtotal-cents]') || scopedQuery('.totals');

        if (!subtotalRow) return null;

        totalRow = document.createElement('div');
        totalRow.className = 'totals ecomhard-cart-total-with-shipping';
        totalRow.setAttribute('data-cart-shipping-total-row', '');
        totalRow.setAttribute('hidden', 'hidden');
        totalRow.innerHTML = `
          <h2 class="totals__total">Total com frete</h2>
          <p class="totals__total-value" data-cart-shipping-total></p>
        `;

        subtotalRow.insertAdjacentElement('afterend', totalRow);

        return totalRow;
      }

      updateTotal(priceCents = undefined) {
        const totalRow = this.getOrCreateTotalRow();

        if (!totalRow) return;

        const totalValue = totalRow.querySelector('[data-cart-shipping-total]');

        if (!totalValue) return;

        let currentPriceCents = priceCents;

        if (typeof currentPriceCents === 'undefined' && this.selectedRate) {
          currentPriceCents = priceToCents(this.selectedRate);
        }

        if (currentPriceCents === null || typeof currentPriceCents === 'undefined') {
          totalRow.setAttribute('hidden', 'hidden');
          totalRow.classList.add('hidden');
          totalValue.textContent = '';
          return;
        }

        const subtotalCents = this.getSubtotalCents();

        totalValue.textContent = formatPrice(subtotalCents + currentPriceCents);
        totalRow.removeAttribute('hidden');
        totalRow.classList.remove('hidden');
      }

      renderMessage(message) {
        this.domNodes.message.innerHTML = '';

        const messageElement = document.createElement('p');
        messageElement.className = 'f-cart-shipping__message-text';
        messageElement.textContent = message;

        this.domNodes.message.appendChild(messageElement);
      }

      getErrorMessage(result) {
        return getErrorMessageFromResult(result);
      }

      setLoading(isLoading) {
        this.classList.toggle('is-loading', isLoading);

        if (this.domNodes?.zipCode) {
          this.domNodes.zipCode.toggleAttribute('readonly', isLoading);
        }
      }
    }
  );
}